import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getCookie } from "../../../utils/cookie";
import { 
  Background, 
} from "../../../common/Faq/styles";
import { useNavigate } from "react-router-dom";
import {
  SettingsHeader,
  Title
} from '../styles';
import BackButton from "../../Products/BackButton";
import { toast } from "react-toastify";
import { publicAPI, privateAPI } from "../../../utils/api";
import { CartProductWrapper } from './styles';
import CartProduct from './Product';
import Grid from "@mui/material/Grid";
import { HeaderTextButton } from '../../../common/Header/styles';
import NoProduct from "../GenericComponents/NoItems";

const Cart = () => {
  const [userID] = useState(getCookie('userId'));
  const navigate = useNavigate();
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [chartIds, setChartIds] = useState([]);
  const [userCart, setUserCart] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserCart = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/cart/${userID}`);
      setChartIds(response.data.cartProducts);
      let listOfCart = [];

      if (response.data.length === 0) {
        setUserCart(listOfCart);
      } else {
        const result = response.data.cartProducts.map(async (item) => {
          try{
              const product = await publicAPI.get(`/public/bacchus/product/${item.id}`);
              product.data.cartQuantity = item.quantity;
              listOfCart.push(product.data);
          } catch (error) {
            console.error(`Error fetching product with ID ${item.id}:`, error);
          }
        })
        await Promise.all(result);
        setUserCart(listOfCart);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getUserCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>
            Cart
          </Title>
        </SettingsHeader>
        {userCart.length === 0 ? 
          <NoProduct/>
          :
          <CartProductWrapper>
            <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
              {userCart.map((item, index) => 
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  key={`${item.id}_${item.name}`}
                  >
                    <CartProduct
                      key={item.id}
                      item={item}
                      productID={chartIds[index]?.id}
                      getUserCart={getUserCart}/>
                </Grid>
              )}
            </Grid>
          </CartProductWrapper>
        }
        {userCart.length ? <HeaderTextButton cream onClick={() => navigate('/profile/checkout')}>Go to checkout</HeaderTextButton> : <></>}
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default Cart;
